<template>
  <v-app>
    <TheNavbar
      :class="{
        'd-none': hideOnMobile,
        'd-sm-block': hideOnMobile
      }"
    />

    <v-main
      class="grey lighten-4"
      :class="{ 'pt-0': hideOnMobile, 'pt-sm-15': hideOnMobile }"
    >
      <v-container class="pa-0" fluid>
        <v-sheet elevation="1" color="grey lighten-5">
          <v-row justify="center" no-gutters>
            <v-col md="8">
              <v-tabs
                :class="{
                  'd-none': hideOnMobile,
                  'd-sm-block': hideOnMobile
                }"
                background-color="grey lighten-5"
              >
                <v-tab class="text-none" :to="{ name: 'home' }">
                  E-Invites
                </v-tab>
                <v-tab class="text-none" href="/blog" target="_blank">
                  Ideas
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>
        </v-sheet>
      </v-container>

      <router-view></router-view>

      <v-snackbar v-model="getSnakbar.flag" :color="getSnakbar.color" right top>
        {{ getSnakbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn
            dark
            small
            fab
            text
            class="float-right px-0"
            v-bind="attrs"
            @click="getSnakbar.flag = !getSnakbar.flag"
          >
            <v-icon>{{ mdiCloseCircleOutline }}</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <!-- LOGIN DALOG -->
      <LoginDialog></LoginDialog>
    </v-main>

    <TheFooter
      v-if="$store.state.show_footer"
      :class="{
        'd-none': hideOnMobile,
        'd-sm-flex': hideOnMobile
      }"
    />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import { mdiCloseCircleOutline } from "@mdi/js";
import LoginDialog from "@/components/dialogs/LoginDialog.vue";
import TheNavbar from "@/components/TheNavbar";

export default {
  name: "App",
  metaInfo: {
    title:
      "Invitation card maker: Easily make invitation cards for your wedding, engagement, haldi and more",
    titleTemplate: "%s - WedNicely",
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        vmid: "description",
        name: "description",
        content:
          "Say goodbye to the time-consuming process of designing wedding invitation card and make wedding invitation on the go with WedNicely's wedding invitation card maker. Add details to templates and instantly make downloadable wedding invitations."
      },
      { name: "msapplication-TileColor", content: "#ee3a84" },
      { name: "theme-color", content: "#ee3a84" },
      { name: "p:domain_verify", content: "00bfb061daa7220ba6c82a91bfb84b4c" }
    ]
  },

  components: {
    TheNavbar,
    TheFooter: () => import("@/components/TheFooter"),
    LoginDialog
  },

  data() {
    return {
      mdiCloseCircleOutline
    };
  },

  computed: {
    ...mapGetters({
      getSnakbar: "snackbar/getSnakbar"
    }),

    hideOnMobile() {
      return !["home", "freeInvitePreview"].includes(this.$route.name);
    }
  }
};
</script>

<style src="./styles/common.css"></style>
